import axios from "axios";
import { CUSTOMER_GROUPS_URL, CUSTOMER_CHECK_URL, PRODUCT_CHECK_URL } from "../../../../../constants/config";

//call api to fetch customer groups
export function findCustomerGroups(queryParams) {
    return axios.get(
        `${CUSTOMER_GROUPS_URL}/list?search_key=${queryParams?.searchKey || ""}&is_active=${queryParams?.is_active ?? 1}&page=${queryParams.pageNumber || 1
        }&page_size=${queryParams.pageSize || 20}&sort_by=${queryParams.sort_by || "updated_at:desc"}`
    );
}

export function createCustomerGroup(customerGroup) {
    return axios.post(`${CUSTOMER_GROUPS_URL}`, customerGroup);
}

export function checkCustomer(payload) {
    return axios.post(`${CUSTOMER_CHECK_URL}`, payload);
}

export function getCustomerGroupById(id) {
    return axios.get(`${CUSTOMER_GROUPS_URL}/${id}`);
}

export function updateCustomerGroup(id, customerGroup) {
    return axios.put(`${CUSTOMER_GROUPS_URL}/${id}`, customerGroup);
}

export function deleteCustomerGroup(id) {
    return axios.delete(`${CUSTOMER_GROUPS_URL}/${id}`);
}

export function customerGroupPricing(id, payload) {
    return axios.put(`${CUSTOMER_GROUPS_URL}/${id}/pricing`, payload);
}

export function productCheck(payload) {
    return axios.post(`${PRODUCT_CHECK_URL}`, payload);
}